module.exports = __webpack_public_path__ + "static/media/mp4.dde8b5da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/mp4.svg
// module id = 1689
// module chunks = 17